import React from 'react';
import {Invoice} from "./utils";

interface Props {
  result: Invoice;
}

const BondDisplayComponent: React.FC<Props> = ({ result }) => {

  const handleDownloadJSON  = () => {
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(result));
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", "invoice_" + result.invoiceNumber + ".json");
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  };

  const convertToCSV = (obj: Invoice) => {
    // const replacer = (key: string, value: any) => value === null ? '' : value;
    const header = Object.keys(obj).join(',');
    const csv = [
      header,
      Object.entries(obj).map(kv => kv[1]).join(',')
    ].join('\n');
    return csv;
  };

  const handleDownloadCSV = () => {
    const csvData = convertToCSV(result);
    const dataStr = "data:text/csv;charset=utf-8," + encodeURIComponent(csvData);
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", "invoice_" + result.invoiceNumber + ".csv");
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  };

  return (
    <div>
      <div className="result-card">
        <div>
          <label>Invoice Number:</label> <span className={"text"}>{result.invoiceNumber}</span>
        </div>
        <div>
          <label>Vendor:</label> <span className={"text"}>{result.vendorName}</span>
        </div>
        <div>
          <label>Order Number:</label> <span className={"text"}>{result.orderNumber}</span>
        </div>
        <div>
          <label>Product Description:</label> <span className={"text"}>{result.productDescription}</span>
        </div>
        <div>
          <label>Customer Number:</label> <span className={"text"}>{result.customerNumber}</span>
        </div>
        <div>
          <label>VAT:</label> <span className={"text"}>{result.totalVat}</span>
        </div>
        <div>
          <label>Amount:</label> <span className={"text"}>{result.grossAmount}&nbsp;{result.currency}</span>
        </div>
      </div>
      {/*<button type="submit" className={"button"} onClick={handleDownloadJSON }>Download JSON</button>*/}
      {/*<button type="button" className="button" onClick={handleDownloadCSV}>Download CSV</button>*/}
      <div style={{ display: 'flex', borderRadius: '24px', overflow: 'hidden' }}>
        <button
          type="button"
          className="button"
          onClick={handleDownloadJSON}
          style={{ flex: 1, borderRight: '1px solid white' }}
        >
          JSON
        </button>
        <button
          type="button"
          className="button"
          onClick={handleDownloadCSV}
          style={{ flex: 1 }}
        >
          CSV
        </button>
      </div>
    </div>
  );

};

export default BondDisplayComponent;
